import { z } from 'zod';

export const AssessmentQuestionSchema = z.object({
    id: z.string().optional(),
    name: z.string().min(1, "Name is required"),
    description: z.string().optional(),
    questions: z.array(z.object({
        id: z.string().optional(),
        title: z.string().min(1, "Question title is required"),
        description: z.string().optional(),
        order: z.number().optional(),
        type: z.string().optional(),
    })).min(1, "At least one question is required"),
    status: z.string().optional().default('active'),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});
export const CreateAssessmentQuestionSchema = AssessmentQuestionSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateAssessmentQuestionSchema = AssessmentQuestionSchema.partial();
export const AssessmentQuestionFormSchema = z.object({
    assessmentId: z.number().min(1, "Assessment ID is required"),
    question: z.string().min(1, "Question is required"),
    category: z.string().min(1, "Category is required"),
    weight: z.number().min(1).max(10).default(1),
    isRequired: z.boolean().default(true),
    order: z.number().min(1).default(1),
});

